var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11L8.13895 8.63474L10.5 11ZM9.44737 5.47368C9.44737 6.66018 8.97604 7.79808 8.13706 8.63706C7.29808 9.47604 6.16018 9.94737 4.97368 9.94737C3.78719 9.94737 2.64929 9.47604 1.81031 8.63706C0.971333 7.79808 0.5 6.66018 0.5 5.47368C0.5 4.28719 0.971333 3.14929 1.81031 2.31031C2.64929 1.47133 3.78719 1 4.97368 1C6.16018 1 7.29808 1.47133 8.13706 2.31031C8.97604 3.14929 9.44737 4.28719 9.44737 5.47368V5.47368Z",
    stroke: "#7C76B5",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying_glass.7137d271cd844c83435c010a3a8f622b.svg";
export { ForwardRef as ReactComponent };